"use strict";
//@ts-nocheck
// Auto-generated via `yarn polkadot-types-from-chain`, do not edit
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
require("./augment-api-consts");
require("./augment-api-errors");
require("./augment-api-events");
require("./augment-api-query");
require("./augment-api-tx");
require("./augment-api-rpc");
//# sourceMappingURL=augment-api.js.map